import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useAppSelector } from 'src/Hooks/redux'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { useScheduleEvents } from 'src/Hooks/useScheduleEvents'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { useReels } from 'src/Hooks/useReels'

export const useScheduleStartEvent = (): void => {
  const { number: campaignIdParams } = useParams()
  const { handleScheduleStartEvent } = useScheduleEvents()
  const { isReelsCampaign } = useReels()
  const scheduledTikTokCampaign = useAppSelector(getScheduledTikTokCampaign)
  const campaignId = scheduledTikTokCampaign?.id
  const campaignType = scheduledTikTokCampaign?.type || CampaignTypeEnum.BASIC

  useEffect(() => {
    if (String(campaignId) !== String(campaignIdParams)) {
      return
    }
    handleScheduleStartEvent({
      campaignType,
      platformName: isReelsCampaign
        ? CampaignPlatformTypeEnum.REELS
        : CampaignPlatformTypeEnum.TIKTOK,
      campaignId: Number(campaignId),
      genreList: '',
    })
  }, [
    campaignIdParams,
    campaignId,
    campaignType,
    handleScheduleStartEvent,
    isReelsCampaign,
  ])
}
